import templateComponents from '../../../Template/theme/components'
import scorecard from './scorecard'

export default {
    ...templateComponents,
    scorecard
}